import { SubscriptionSelection } from "../SubscriptionSelection.js";
import { SubscriptionVariant } from "../SubscriptionVariant.js";

export function getSubscriptionSelectionsForVariant(variant: SubscriptionVariant): SubscriptionSelection[] {
	if (variant === SubscriptionVariant.Filter) {
		return [SubscriptionSelection.FathersChoice];
	}
	return Object.values(SubscriptionSelection);
}
